<template>
  <ViewWrapper headingText="Email Outgoing">
    <EmailOutgoing></EmailOutgoing>
  </ViewWrapper>
</template>

<script>
import ViewWrapper from '@/components/ViewWrapper'
import EmailOutgoing from '@/components/manage/EmailOutgoing'

export default {
  components: { ViewWrapper, EmailOutgoing }
}
</script>



// WEBPACK FOOTER //
// src/components/manage/EmailOutgoingPage.vue